module.exports = __webpack_public_path__ + "play-pause.svg";


//////////////////
// WEBPACK FOOTER
// ./~/blueimp-gallery/img/play-pause.svg
// module id = 1192
// module chunks = 6